<template>
  <div
    v-if="state && items.length > 0"
    class="ais-RefinementList"
  >
    <h3
      class="h6 muted text-uppercase"
      style="letter-spacing: var(--letter-spacing-2xl)"
    >
      Style
    </h3>
    <ul
      class="icons-facets-group-styles"
      style="--list-style-type: none; --padding-left: 0; --margin-top: 0; --margin-bottom: var(--spacing-2xl)"
    >
      <li
        v-for="item in items"
        :key="item.value"
        class="wrap-icons-facet-input margin-bottom-5xs"
      >
        <input
          :id="`icons-style-${item.label}`"
          type="checkbox"
          name="styles"
          class="with-icon"
          :checked="item.isRefined"
          @change="applyFacet(item.value, item.isRefined)"
        />

        <label
          :for="`icons-style-${item.label}`"
          class="icons-facet icons-facet-input margin-0 flex-row size-sm flex-items-baseline"
          style="padding: var(--spacing-2xs) var(--spacing-sm); cursor: pointer; display: flex !important"
        >
          <span class="icons-facet-affordance position-relative margin-right-sm">
            <font-awesome-icon
              :icon="icon(item.value)"
              fixed-width
              class="unchecked-icon"
            />

            <font-awesome-icon
              :icon="$v6.regular.faSquare"
              fixed-width
              class="hover-icon"
            />
            <font-awesome-icon
              :icon="$v6.solid.faSquareCheck"
              fixed-width
              class="checked-icon"
            />
          </span>

          <span style="flex-grow: 1; flex-shrink: 1; flex-basis: auto">
            <span class="sr-only">
              <template v-if="item.isRefined">Showing&nbsp;</template>
              <template v-else>Show&nbsp;</template>
            </span>
            <span class="text-capitalize">{{ item.value }}</span>
            <span class="sr-only">&nbsp;style icons</span>
          </span>

          <span class="icons-facet-count margin-left-sm">
            {{ item.count.toLocaleString() }}
            <span class="sr-only">matching results</span>
          </span>
        </label>
      </li>
    </ul>
  </div>
</template>

<script>
  import { createWidgetMixin } from 'vue-instantsearch'
  import { connectRefinementList } from 'instantsearch.js/es/connectors'
  import { sortStyles } from '../utils.js'

  export default {
    name: 'StyleListFacet',

    mixins: [createWidgetMixin({ connector: connectRefinementList })],

    computed: {
      version() {
        return this.$releases.active.versionParts.major
      },

      widgetParams() {
        return {
          attribute: 'style',
          limit: 100,
          sortBy: ['name:asc'],
          operator: 'or',
          transformItems: this.transformItems
        }
      },

      items() {
        return this.state != null ? this.state.items : null
      }
    },

    methods: {
      applyFacet(value, isRefined) {
        this.state.refine(value)
        this.$emit('scrollTop')
        this.$emit('closeIcon')
        this.$emit('applyFacet', !isRefined)

        if (value !== 'None') {
          this.$posthog.capture('icon_search:style_facet_button_click', { facet: value })
        }
      },

      transformItems(items) {
        return sortStyles(items)
      },

      icon(style) {
        switch (style) {
          case 'solid':
            return this.$v6.solid.faCircle
          case 'duotone':
            return this.$v6.duotone.faCircleHalf // duotone as a style is required for v5
          default:
            return this.$v6[style].faCircleHalfStroke
        }
      }
    }
  }
</script>
